import { Component, Input, OnInit } from '@angular/core';

import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { FilterTypesEnum } from 'src/app/models/filters/filterTypes.enum';
import { PlaybooksFiltersModel } from 'src/app/models/filters/implementations/pageFilters/playbooksFilters.model';
import { ISelectOption } from 'src/app/models/selectOptions';
import { PermissionsService } from 'src/app/services/infra/permissionsService/permissions.service';
import { PERMISSIONS } from 'src/app/models/permissions/permissions.const';

@Component({
  selector: 'app-playbooks-filters',
  templateUrl: './playbooks-filters.component.html',
  styleUrls: ['./playbooks-filters.component.scss'],
})
export class PlaybooksFiltersComponent implements OnInit {
  @Input() public pageFilters: PlaybooksFiltersModel;
  @Input() public withCreateButton: boolean;
  @Input() public playbooksCount: number;
  public clearCustomViewSelection$ = new BehaviorSubject(undefined);

  public selectedOptions: ISelectOption[] = [];

  public searchBoxNewValue = new ReplaySubject<string | undefined>(1);
  public lastExecutionSinceNewValue = new ReplaySubject<Date | undefined>(1);
  public lastExecutionUntilNewValue = new ReplaySubject<Date | undefined>(1);
  public selectedCustomOption?: ISelectOption;
  public readonly maxPlaybooksCount: number = 150;

  private _customViewTriggered = false;

  constructor(public permissionsService: PermissionsService) {}

  ngOnInit(): void {
    this.pageFilters.onUpdate$.subscribe((data) => {
      this.selectedOptions = this.pageFilters.getAllSelectedOptions();

      this.searchBoxNewValue.next(data.search);
      this.lastExecutionSinceNewValue.next(data.lastExecutionSince);
      this.lastExecutionUntilNewValue.next(data.lastExecutionUntil);

      if (this._customViewTriggered) {
        this._customViewTriggered = false;
      } else {
        this.clearCustomViewSelection$.next(undefined);
        this.selectedCustomOption = undefined;
      }
    });
  }

  public tablesFiltersChange(selectedOptions: ISelectOption[]) {
    this.pageFilters.updateFilterFromUserSelection(undefined, selectedOptions);
  }

  public lastExecutionSinceSelected(value?: Date): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.LastExecutionSince, value);
  }

  public lastExecutionUntilSelected(value?: Date): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.LastExecutionUntil, value);
  }

  public searchSubmitted(value?: string): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.Search, value);
  }

  public playbookCreationAllowed(): boolean {
    return (
      this.permissionsService.userHasPermission(PERMISSIONS.PLAYBOOK_OPERATION) &&
      this.playbooksCount < this.maxPlaybooksCount
    );
  }
}
